import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './Header.css';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user } = useAuth();

  const navLinks = [
    { to: '/', label: 'Accueil' },
    { to: '/a-propos', label: 'À propos' },
    { to: '/tournois', label: 'Tournois' },
    { to: '/classement', label: 'Classement' },
    { to: '/statistiques', label: 'Statistiques' },
    { to: '/palmares', label: 'Palmarès' },
  ];

  return (
    <header className="header">
      <div className="header__inner container">
        <Link to="/" className="header__logo honk-title">
          Champions Collective
        </Link>

        <button
          className="header__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu de navigation"
          aria-expanded={menuOpen}
        >
          <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
          <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
          <span className={`hamburger-line ${menuOpen ? 'open' : ''}`} />
        </button>

        <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
          <ul className="header__links">
            {navLinks.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `header__link staatliches-regular ${isActive ? 'header__link--active' : ''}`
                  }
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </NavLink>
              </li>
            ))}
            <li>
              <a
                href="https://discord.gg/8PtsyHNPru"
                target="_blank"
                rel="noopener noreferrer"
                className="header__link staatliches-regular"
                onClick={() => setMenuOpen(false)}
              >
                Discord
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
